const KUISKAA_CANDIDATES_PULINABOTTI = Object.freeze([
  {
    userId: '__kuiskaa:pulinabotti',
    username: 'pulinabotti',
    displayName: 'pulinabotti',
  },
]);

/** /kuiskaa autocomplete: only pulinabotti (private chat with the bot). */
export function buildKuiskaaCandidates() {
  return KUISKAA_CANDIDATES_PULINABOTTI;
}

/** If raw is `/kuiskaa target [body]`, returns { target, body }; otherwise null. */
export function parseKuiskaaMessage(raw) {
  const m = String(raw || '').trim().match(/^\/kuiskaa\s+(\S+)(?:\s+(.*))?$/i);
  if (!m) return null;
  const target = m[1].trim();
  const body = (m[2] || '').trim() || '(kuiskaus)';
  if (!target) return null;
  return { target, body };
}
